'use strict';

// Note: potentially could be moved to int_voyado (together with voyado/ sub-directory).

import Provider from './voyado/eventProvider';

document.addEventListener('integration:event-provider', function (event) {
    event.detail.dispatcher.register(new Provider());
});
